'use strict';

var util = require('./util'),
	dialog = require('./dialog');

var page = {
	title: '',
	type: '',
	params: util.getQueryStringParams(window.location.search.substr(1)),
	redirect: function (newURL) {
		setTimeout(function () {
			window.location.href = newURL;
		}, 0);
	},
	refresh: function () {
		setTimeout(function () {
			window.location.assign(window.location.href);
		}, 500);
	},
	searchToggle: function () {
		$( "button.search-toggle" ).on( "click", function( event ) {
			$(this).toggleClass("active").find('i').toggleClass("fa-search fa-times");
			$('.language, .menu-utility-user, #mini-cart').toggleClass("search-active");
			$('.header-search').toggle();
		});
	},
	setupNewsletter: function(){
		$('.shownewsletter, li.menu-item.newsletter a').click(function(e){
			e.preventDefault();
			$.ajax({
				url: $(this).attr('href')
			}).done(function(data){
				dialog.open({
					html: data, 
					options: {
						dialogClass:'newsletter-signup-dialog',
						width: 540
					}
				});
				$('.newsletter-signup form').on('submit',function(e){
					e.preventDefault();
					jQuery.ajax({
						url : $(this).attr("action"),
						data : $(this).serialize(),
						dataType: "html",
						type : "POST",
					}).done(function(data){
						$(".newsletter-signup").html(data);
					});
				});
			});
		});
	}
};

module.exports = page;
